import { TopAreaWrapper } from './top-area.styled'
import { node } from 'prop-types'
import { cx } from '@emotion/css'

const TopArea = ({ childComponent, className }) => {
	return childComponent ? (
		<TopAreaWrapper className={cx('TopArea-root', className)}>{childComponent}</TopAreaWrapper>
	) : null
}

TopArea.propTypes = {
	/**
	 * Defines topArea content
	 */
	childComponent: node,
}

export default TopArea
